<div *ngIf="reportType === 'Monthwise'">
  <div
    id="print-section"
    style="font-family: Arial, sans-serif; border: 1px solid black; margin: 10mm;"
  >
    <!-- ===== HEADER SECTION ===== -->
    <table
      style="width: 100%; border-collapse: collapse; background-color: #f8f9fa; border-bottom: 1px solid black;"
    >
      <tr>
        <td style="font-size: 18px; font-weight: bold; text-align: center; white-space: nowrap; padding: 8px;">
          हिंदुस्तान प्रकाशन संस्था 
        </td>
        <td style="font-size: 20px; font-weight: bold; text-align: center;">
Book Payment Receipt Report
        </td>
        <td style="font-size: 18px; text-align: right; white-space: nowrap; padding: 8px;">
          दिनांक {{ currentDate | date: 'dd-MM-yyyy' }}
        </td>
      </tr>

      <tr style="border-top: 1px solid black;">
        <td style="padding: 8px;font-weight: bold;font-size: 18px;text-align: center;"> विवेक पुस्तक प्रकाशन</td>
        <td style="font-size: 18px; font-weight: bold; text-align: center; padding: 8px;">
          Monthwise
        </td>
        <td style="font-size: 16px; text-align: right; white-space: nowrap; padding: 8px;">
          Date : From {{ startDate | date:'dd-MM-yyyy' }} To {{ endDate | date:'dd-MM-yyyy' }}
        </td>
      </tr>
    </table>

    <!-- ===== BUTTON SECTION ===== -->
    <!-- <div class="noPrint" style="text-align: right; margin: 10px;">
      <button
        (click)="printPage4()"
        style="
          background-color: #4caf50;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          margin-right: 5px;
          cursor: pointer;
        "
      >
        🖨️ Print
      </button>

      <button
        (click)="exportToExcel()"
        style="
          background-color: #2196f3;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          cursor: pointer;
        "
      >
        ⬇️ Export to Excel
      </button>
    </div> -->

    <!-- ===== REPORT TABLE ===== -->
    <table
      style="width: 100%; border-collapse: collapse; border: 1px solid black; text-align: right;"
    >
      <thead>
        <tr
          style="background-color: #dfe6e9; border-bottom: 1px solid black;"
        >
          <th
            style="text-align: left; padding: 6px; border: 1px solid black;"
          >
            Office Representative
          </th>
          <th
            *ngFor="let month of monthList"
            style="padding: 6px; border: 1px solid black;"
          >
            {{ month }}
          </th>
          <th style="padding: 6px; border: 1px solid black;">Total</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let data of monthwiseData">
          <td
            style="text-align: left; padding: 6px; border: 1px solid black;"
          >
            {{ data.office_rep_name }}
          </td>
          <td
            *ngFor="let month of monthList"
            style="padding: 6px; border: 1px solid black;"
          >
            {{ (data[month] || 0) | number: '1.0-0' }}
          </td>
          <td
            style="padding: 6px; border: 1px solid black; font-weight: bold;"
          >
            {{ getRowTotal(data) | number: '1.0-0' }}
          </td>
        </tr>
      </tbody>

      <tfoot>
        <tr style="font-weight: bold; background-color: #c8753f;">
          <td
            style="text-align: left; border: 1px solid black; padding: 6px;"
          >
            Monthwise Total
          </td>
          <td
            *ngFor="let month of monthList"
            style="border: 1px solid black; padding: 6px;"
          >
            {{ (monthTotals[month] || 0)  }}
          </td>
          <td style="border: 1px solid black; padding: 6px;">
            {{ overallTotal  }}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div class="noPrint" style="text-align: right; margin: 10px;">
      <button
        (click)="printPage4()"
        style="
          background-color: #4caf50;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          margin-right: 5px;
          cursor: pointer;
        "
      >
        🖨️ Print
      </button>

      <button
        (click)="exportExcel()"
        style="
          background-color: #2196f3;
          color: white;
          border: none;
          padding: 6px 12px;
          border-radius: 6px;
          cursor: pointer;
        "
      >
        ⬇️ Export to Excel
      </button>
       <button
  mat-raised-button
  color="primary"
  class="noPrint"
  mat-dialog-close>
  Close
</button>

    </div>
</div>
